import React from 'react'
import './About360.css'
import abt360 from '../../../../assets/img/abt360.webp'
import { Link } from 'react-router-dom'
import CountUpOnScroll from '../../Home/About/ScrollCounter'

function About360() {
  return (
    <section className='hmslder-sec abt-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li> 
               <li>About 360 Gigabytes</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>About <span>360 Gigabytes</span></h2>
              <p>Over the years we have  established ourselves as the leading service provider for Mobile  Application Development, Website Design & Development, Web and  Graphic Design, E-Commerce Development, Software as a Solution (Saas -  cloud solution), Digital Transformation and Product Engineering company  based out of Chandigarh.</p>
              <p>Our process follows by providing enough focus and  effort to strategic decisions about the solution, followed by a  well-articulated and appropriate design approach and lastly smooth  deployment to ensure smooth operation as it was meant to deliver.</p>
            </div> 
           <div className='hmslder-img'>
            <img src={abt360} alt='About 360 Gigabytes' width={1200} height={800} loading="lazy" />
            <div className='yoe'><h4> <CountUpOnScroll end={10} /></h4><p>Years Experience</p></div>
            </div>  
        </div>
    </section>
  )
}

export default About360
